<template>
  <div class="home">
    <!-- Hero Section -->
    <section class="hero">
      <canvas class="hero-canvas" ref="heroCanvas"></canvas>
      <div class="hero-content">
        <h1 class="animate-up">以智能标尺，链动万物新可能</h1>
        <p class="animate-up delay-1">星矩链动是以AI与软件技术赋能传统行业,实现智能化升级与数字化转型</p>
        <div class="hero-actions animate-up delay-2">
          <button class="btn btn-primary" @click="scrollExplore">探索更多</button>
          <button class="btn btn-outline" @click="goContact">联系我们</button>
        </div>
      </div>
    </section>

    <!-- SOLO Mode Section -->
    <section class="section solo-mode">
      <div class="container">
        <div class="solo-header">
          <h2>和 星矩链动 一起开启 <span class="highlight">AI创作</span></h2>
          <!-- <button class="btn btn-primary btn-solo">
            <span class="icon">⚡</span> 即刻探索 SOLO
          </button> -->
        </div>
        <div class="video-showcase">
             <div class="carousel-viewport" ref="videoViewport">
                <div class="carousel-track" :style="videoTrackStyle">
                   <div class="case-card video-card" v-for="(video, index) in videos" :key="index" :class="{ active: currentVideo === index }" @click="handleVideoCardClick(index)">
                      <div class="card-image video-container">
                         <video ref="carouselVideos" :src="video.src" loop muted playsinline controls @play="handleVideoPlay(index)" @pause="handleVideoPause(index)" @click="toggleVideoState(index)"></video>
                         <div class="play-overlay" v-show="!videoPlayingStates[index]">
                            <div class="play-icon">▶</div>
                         </div>
                      </div>
                   </div>
                </div>
             </div>
          </div>
      </div>
    </section>

    <!-- Horizontal Scroll Section (Merged) -->
    <section class="horizontal-scroll-section" ref="scrollSection" :style="{ height: scrollHeight + 'px' }">
      <div class="sticky-wrapper">
        <div class="horizontal-track" :style="{ transform: `translateX(-${scrollX}px)` }" ref="track">

          <!-- Title Block -->
          <div class="scroll-item title-block">
            <h2 class="title-with-decoration">星矩链动 为你解锁<br>
              <span class="highlight-container">
                <span class="highlight">全新可能</span>
              </span>
            </h2>
          </div>

          <!-- Card 1: Full Chain Solution (Merged) -->
          <div class="scroll-item feature-card">
            <div class="card-number">[01]</div>
            <h3>全链条智能化解决方案</h3>
            <p class="card-desc">专注通过人工智能与软件技术，提供从技术研发、模型训练到系统部署、落地运维的全流程服务，推动传统行业智能化升级。</p>
            <div class="card-icon">⚙️</div>
          </div>

          <!-- Card 2: Custom Dev -->
          <div class="scroll-item feature-card">
            <div class="card-header">
              <div class="card-number">[02]</div>
              <div class="category-label">合作模式</div>
            </div>
            <h3>定制化系统开发</h3>
            <div class="card-content-list">
              <p class="sub-title">需求分析 → 研发 → 交付 → 维护</p>
              <ul>
                 <li>针对企业特定业务流程定制</li>
                 <li>全生命周期服务</li>
              </ul>
            </div>
          </div>

          <!-- Card 3: AI Model -->
          <div class="scroll-item feature-card">
            <div class="card-header">
              <div class="card-number">[03]</div>
              <div class="category-label">合作模式</div>
            </div>
            <h3>AI模型训练与部署</h3>
            <div class="card-content-list">
              <p class="sub-title">数据清洗 → 模型训练 → 调优 → 部署</p>
              <ul>
                 <li>专业数据处理</li>
                 <li>高性能模型交付</li>
              </ul>
            </div>
          </div>

          <!-- Card 4: Digital Trans -->
          <div class="scroll-item feature-card">
            <div class="card-header">
              <div class="card-number">[04]</div>
              <div class="category-label">合作模式</div>
            </div>
            <h3>传统流程数字化改造</h3>
            <div class="card-content-list">
              <p class="sub-title">现状诊断 → 方案设计 → 系统集成 → 优化</p>
              <ul>
                 <li>深入业务场景诊断</li>
                 <li>无缝系统集成</li>
              </ul>
            </div>
          </div>

        </div>
      </div>
    </section>

    <!-- Successful Cases Section -->
    <section class="section cases">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">成功案例</h2>
        </div>

        <div class="carousel-viewport" ref="viewport">
          <div class="carousel-track" :style="trackStyle">
            <!-- Case 1: Industrial Inspection -->
            <div class="case-card" :class="{ active: currentCase === 0 }" @click="goTo(0)">
              <div class="card-image">
                <img src="/shoe.jpeg" alt="鞋业质检">
              </div>
              <div class="card-content">
                <div class="card-left">
                  <h3>工业质检</h3>
                  <span class="subtitle">AI视觉检测</span>
                </div>
                <div class="card-right">
                  <p class="desc"><strong>痛点：</strong>人工质检效率低、误检率高</p>
                  <p class="desc"><strong>方案：</strong>与百度飞桨AI中心联合研发，基于CV的自动缺陷检测系统</p>
                  <div class="tags">
                    <span>效率提升300%</span>
                    <span>漏检率&lt;0.1%</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Case 2: Enterprise System -->
            <div class="case-card" :class="{ active: currentCase === 1 }" @click="goTo(1)">
              <div class="card-image">
                <img src="/shen.jpeg" alt="深南电路">
              </div>
              <div class="card-content">
                <div class="card-left">
                  <h3>半导体生产</h3>
                  <span class="subtitle">AI算法辅助</span>
                </div>
                <div class="card-right">
                  <p class="desc"><strong>痛点：</strong>生产数据孤岛、管理困难</p>
                  <p class="desc"><strong>方案：</strong>定制化数字化管理系统 (数据可视化、流程监控)</p>
                  <div class="tags">
                    <span>管理效率+40%</span>
                    <span>实时管控</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Case 3: Generative AI (E-commerce) -->
            <div class="case-card" :class="{ active: currentCase === 2 }" @click="goTo(2)">
              <div class="card-image">
                <img src="/cloth.jpeg" alt="电商视觉">
              </div>
              <div class="card-content">
                <div class="card-left">
                  <h3>电商视觉生成</h3>
                  <span class="subtitle">生成式 AI</span>
                </div>
                <div class="card-right">
                  <p class="desc"><strong>功能：</strong>电商视频生成、服装新品虚拟模特展示 (Virtual Try-on)</p>
                  <div class="tags">
                    <span>降低拍摄成本</span>
                    <span>缩短上线周期</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Case 4: Generative AI (Game) -->
            <div class="case-card" :class="{ active: currentCase === 3 }" @click="goTo(3)">
              <div class="card-image">
                <img src="/game.jpeg" alt="游戏角色">
              </div>
              <div class="card-content">
                <div class="card-left">
                  <h3>游戏角色生成</h3>
                  <span class="subtitle">3D模型生成</span>
                </div>
                <div class="card-right">
                  <p class="desc"><strong>功能：</strong>传奇类游戏角色自动化生成、原画到3D资产全流程辅助</p>
                  <div class="tags">
                    <span>生产效率提升</span>
                    <span>风格统一</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Case 6: App Data Center -->
            <div class="case-card" :class="{ active: currentCase === 4 }" @click="goTo(4)">
              <div class="card-image">
                <img src="/star.png" alt="数据中心">
              </div>
              <div class="card-content">
                <div class="card-left">
                  <h3>心理咨询数据</h3>
                  <span class="subtitle">数据平台</span>
                </div>
                <div class="card-right">
                  <p class="desc"><strong>功能：</strong>多维数据集成、可视化大屏、用户行为分析</p>
                  <div class="tags">
                    <span>辅助科学决策</span>
                    <span>实时监控</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>

       <!-- Strategic Partners Section -->
    <section class="section partners">
      <div class="container">
        <h2 class="section-title">产业生态 —— 战略合作伙伴</h2>
        <div class="partners-grid">
          <div class="partner-card">
            <h3>百度飞桨广州中心</h3>
            <p class="partner-desc">共享AI开发平台与算法资源</p>
          </div>
          <div class="partner-card">
            <h3>广州星缘智能</h3>
            <p class="partner-desc">AI技术联合研发与场景落地</p>
          </div>
          <div class="partner-card">
            <h3>百度智能云</h3>
            <p class="partner-desc">提供稳定的云计算与AI模型部署环境</p>
          </div>
        </div>
      </div>
    </section>

    <!-- About Section -->
    <section class="section about-preview">
      <div class="container">
        <div class="about-content">
          <div class="about-text">
            <h2 class="section-title">关于星矩链动</h2>
            <p>星矩链动智能科技有限公司致力于以AI与软件开发技术为核心，赋能传统行业实现智能化升级与数字化转型。</p>
            <p>我们提供从技术研发到落地应用的全链条定制化解决方案，拥有强大的研发和生产能力。</p>
            <router-link to="/about" class="btn btn-primary">了解更多</router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data () {
    return {
      isPlaying: false,
      // Video Carousel Data
      currentVideo: 0,
      videoViewportWidth: 0,
      videoPlayingStates: [false, false, false],
      videos: [
        {
          src: 'https://aster-website.gz.bcebos.com/home_video_2.mp4?authorization=bce-auth-v1/ALTAKsi7IWhkJYpkJCEl5a08lE/2026-07-20T08%3A20%3A33Z/-1/host/d15ed85080de0d50da9784067c190e5072ef1e9a62c36067811478686827710b',
          title: '核心功能演示',
          subtitle: 'AI DRIVEN',
          desc: '星矩链动 AI 以高度自动化的方式，独立推进从需求理解到代码落地的全过程。',
          tags: ['智能调度', '上下文理解']
        },
        {
          src: 'https://aster-website.gz.bcebos.com/K766%20SN%20%2B%208100%20SM-%E5%95%86%E5%8A%A1%E9%A3%8E%E5%AE%A2%E5%8E%85.m4v?authorization=bce-auth-v1/ALTAKsi7IWhkJYpkJCEl5a08lE/2026-07-20T08%3A20%3A50Z/-1/host/c2e630e12eb32773b9eda56e1a82ae0b6b23c9d61a85ac6bc90282122a259a62',
          title: '多模态交互',
          subtitle: 'FUTURE TECH',
          desc: '打破传统开发边界，通过多模态交互实现更直观、更高效的系统构建体验。',
          tags: ['实时反馈', '人机协作']
        },
        {
          src: 'https://aster-website.gz.bcebos.com/KO10%20PW-%E6%9C%A8%E7%BA%B9%E8%BD%BB%E5%A5%A2%E5%A4%A7%E5%B9%B3%E5%B1%82.m4v?authorization=bce-auth-v1/ALTAKsi7IWhkJYpkJCEl5a08lE/2026-07-20T08%3A21%3A07Z/-1/host/6a82335f985a6f1efd368545135234c47510f8c62f862c0219bc3f44c39c032c',
          title: '空间智能设计',
          subtitle: 'SPATIAL AI',
          desc: '融合空间感知与智能布局能力，为复杂场景提供自动化设计解决方案。',
          tags: ['空间感知', '智能布局']
        }
      ],
      currentCase: 0,
      caseCount: 5,
      viewportWidth: 0,
      // Horizontal Scroll Data
      scrollHeight: 0,
      scrollX: 0,
      windowHeight: 0,
      trackWidth: 0,
      heroCtx: null,
      heroRaf: null,
      heroTime: 0,
      // 视频自动播放相关
      videoSectionVisible: false,
      videoObserver: null
    }
  },
  computed: {
    videoTrackStyle () {
      const width = this.videoViewportWidth || this.viewportWidth || window.innerWidth
      if (!width) return {}
      const cardWidth = width * 0.7
      const gap = 30
      const centerOffset = (width - cardWidth) / 2
      const itemOffset = this.currentVideo * (cardWidth + gap)
      const translate = -itemOffset + centerOffset
      return {
        transform: `translateX(${translate}px)`
      }
    },
    trackStyle () {
      if (!this.viewportWidth) return {}
      // Card width is 70% of viewport
      const cardWidth = this.viewportWidth * 0.7
      const gap = 30 // 30px gap
      // Center the active slide
      const centerOffset = (this.viewportWidth - cardWidth) / 2
      const itemOffset = this.currentCase * (cardWidth + gap)
      const translate = -itemOffset + centerOffset

      return {
        transform: `translateX(${translate}px)`
      }
    }
  },
  watch: {
    /**
     * 监听当前视频切换，若视频区域可见则自动播放新选中的视频
     * @param {number} newIndex - 新选中的视频索引
     */
    currentVideo (newIndex) {
      if (this.videoSectionVisible) {
        this.$nextTick(() => {
          this.autoPlayCurrentVideo(newIndex)
        })
      }
    }
  },
  methods: {
    nextVideo () {
      this.currentVideo = (this.currentVideo + 1) % this.videos.length
    },
    prevVideo () {
      this.currentVideo = (this.currentVideo - 1 + this.videos.length) % this.videos.length
    },
    handleVideoCardClick (index) {
      if (this.currentVideo !== index) {
        this.currentVideo = index
      } else {
        this.toggleVideoState(index)
      }
    },
    toggleVideoState (index) {
      const videos = this.$refs.carouselVideos
      if (!videos || !videos[index]) return
      const v = videos[index]
      if (v.paused) {
        // Pause others
        videos.forEach((vid, i) => {
          if (i !== index && !vid.paused) vid.pause()
        })
        v.play()
      } else {
        v.pause()
      }
    },
    handleVideoPlay (index) {
      this.videoPlayingStates[index] = true
    },
    handleVideoPause (index) {
      this.videoPlayingStates[index] = false
    },
    /**
     * 自动播放指定索引的视频（仅当视频区域在视口内时生效）
     * 会先暂停其他正在播放的视频，再播放目标视频
     * @param {number} index - 要播放的视频索引
     */
    autoPlayCurrentVideo (index) {
      const videos = this.$refs.carouselVideos
      if (!videos || !videos[index]) return
      // 暂停其他视频
      videos.forEach((vid, i) => {
        if (i !== index && !vid.paused) {
          vid.pause()
        }
      })
      // 播放目标视频
      const target = videos[index]
      if (target.paused) {
        target.play().catch(() => {
          // 浏览器可能限制自动播放，静默失败
        })
      }
    },
    /**
     * 使用 IntersectionObserver 监测视频展示区域是否进入屏幕中心
     * 当区域进入视口时自动播放当前视频，离开时暂停
     */
    setupVideoAutoPlay () {
      const sectionEl = this.$el.querySelector('.video-showcase')
      if (!sectionEl) return

      this.videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.videoSectionVisible = entry.isIntersecting
            if (entry.isIntersecting) {
              // 视频区域进入视口，自动播放当前选中视频
              this.$nextTick(() => {
                this.autoPlayCurrentVideo(this.currentVideo)
              })
            } else {
              // 视频区域离开视口，暂停所有视频
              const videos = this.$refs.carouselVideos
              if (videos) {
                videos.forEach((vid) => {
                  if (!vid.paused) vid.pause()
                })
              }
            }
          })
        },
        {
          // 当视频区域 50% 以上进入视口时触发
          threshold: 0.5
        }
      )
      this.videoObserver.observe(sectionEl)
    },
    nextCase () {
      this.currentCase = (this.currentCase + 1) % this.caseCount
    },
    prevCase () {
      this.currentCase = (this.currentCase - 1 + this.caseCount) % this.caseCount
    },
    goTo (i) {
      this.currentCase = i
    },
    updateViewportWidth () {
      this.viewportWidth = this.$refs.viewport ? this.$refs.viewport.offsetWidth : window.innerWidth
      this.videoViewportWidth = this.$refs.videoViewport ? this.$refs.videoViewport.offsetWidth : this.viewportWidth
      this.windowHeight = window.innerHeight
      this.updateScrollDimensions()
    },
    updateScrollDimensions () {
      if (this.$refs.track) {
        this.trackWidth = this.$refs.track.scrollWidth
        // The scrollable distance is track width - viewport width
        // We add viewport height to make the scroll feel natural (1px scroll = 1px translate)
        // But usually we want it slower or faster. Let's make it 1:1 for simplicity first.
        // Height = Viewport Height (sticky part) + Scrollable Distance
        const scrollableDistance = this.trackWidth - window.innerWidth
        if (scrollableDistance > 0) {
          this.scrollHeight = this.windowHeight + scrollableDistance
        } else {
          this.scrollHeight = this.windowHeight // No scroll needed
        }
      }
    },
    handleScroll () {
      if (!this.$refs.scrollSection) return

      const rect = this.$refs.scrollSection.getBoundingClientRect()

      // Calculate how much we have scrolled into the section
      // rect.top is the distance from viewport top to section top.
      // When rect.top is 0, we are at the start.
      // When rect.top is -(scrollHeight - windowHeight), we are at the end.

      const offset = -rect.top
      const maxScroll = this.scrollHeight - this.windowHeight

      if (offset < 0) {
        this.scrollX = 0
      } else if (offset > maxScroll) {
        this.scrollX = this.trackWidth - window.innerWidth
      } else {
        this.scrollX = offset
      }
    },
    initHeroParticles () {
      const canvas = this.$refs.heroCanvas
      if (!canvas) return
      const dpr = window.devicePixelRatio || 1
      const w = canvas.clientWidth
      const h = canvas.clientHeight
      canvas.width = Math.floor(w * dpr)
      canvas.height = Math.floor(h * dpr)
      const ctx = canvas.getContext('2d')
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0)
      this.heroCtx = ctx
    },
    drawHeroFrame () {
      if (!this.heroCtx) return
      const canvas = this.$refs.heroCanvas
      const w = canvas.clientWidth
      const h = canvas.clientHeight
      const ctx = this.heroCtx
      ctx.clearRect(0, 0, w, h)
      const accent = getComputedStyle(document.documentElement).getPropertyValue('--accent') || '#22e58f'
      const spacing = 14
      const size = 3
      const amp = 70
      const freq = 0.012
      const t = this.heroTime
      const rgb = this.hexToRgb(accent)
      for (let x = 0; x < w; x += spacing) {
        const yWave = h * 0.5 + Math.sin(x * freq + t) * amp
        for (let y = 0; y < h; y += spacing) {
          const d = Math.abs(y - yWave)
          let a = 0.06
          if (d < 12) a = 0.9
          else if (d < 24) a = 0.35
          else if (d < 40) a = 0.15
          ctx.fillStyle = `rgba(${rgb}, ${a})`
          ctx.fillRect(x, y, size, size)
        }
      }
      this.heroTime += 0.03
      this.heroRaf = requestAnimationFrame(this.drawHeroFrame)
    },
    resizeHeroParticles () {
      this.initHeroParticles()
    },
    hexToRgb (hex) {
      const h = hex.trim().replace('#', '')
      const r = parseInt(h.substring(0, 2), 16)
      const g = parseInt(h.substring(2, 4), 16)
      const b = parseInt(h.substring(4, 6), 16)
      return `${r}, ${g}, ${b}`
    },
    scrollExplore () {
      const container = this.$el
      const target =
        container.querySelector('.solo-mode') ||
        container.querySelector('.horizontal-scroll-section') ||
        container.querySelector('.section')
      if (target) {
        const top = window.scrollY + target.getBoundingClientRect().top
        window.scrollTo({ top, behavior: 'smooth' })
      } else {
        window.scrollBy({ top: Math.round(window.innerHeight * 0.8), behavior: 'smooth' })
      }
    },
    goContact () {
      if (this.$router) {
        this.$router.push('/contact')
      } else {
        window.location.href = '/contact'
      }
    }
  },
  mounted () {
    this.updateViewportWidth()
    window.addEventListener('resize', this.updateViewportWidth)
    window.addEventListener('scroll', this.handleScroll)
    // Recalculate after a short delay to ensure DOM is fully rendered
    setTimeout(this.updateScrollDimensions, 500)
    this.initHeroParticles()
    this.drawHeroFrame()
    window.addEventListener('resize', this.resizeHeroParticles)
    // 初始化视频自动播放监测
    this.$nextTick(() => {
      this.setupVideoAutoPlay()
    })
  },
  unmounted () {
    window.removeEventListener('resize', this.updateViewportWidth)
    window.removeEventListener('scroll', this.handleScroll)
    if (this.heroRaf) cancelAnimationFrame(this.heroRaf)
    window.removeEventListener('resize', this.resizeHeroParticles)
    // 清理视频观察器
    if (this.videoObserver) {
      this.videoObserver.disconnect()
      this.videoObserver = null
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  font-family: 'PingFang SC', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  background-color: var(--bg);
}

.hero {
  position: relative;
  height: 650px;
  background: radial-gradient(1200px 400px at 50% 40%, #0e141a 0%, #0b0f13 60%);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
  padding: 0 20px;
  overflow: hidden;

  .hero-canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    opacity: 0.6;
    mix-blend-mode: lighten;
    pointer-events: none;
  }

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-image:
      radial-gradient(circle at 20% 30%, rgba(255,255,255,0.05) 0%, transparent 10%),
      radial-gradient(circle at 80% 70%, rgba(255,255,255,0.05) 0%, transparent 10%);
    background-size: 100% 100%;
    top: 0;
    left: 0;
  }

  // Abstract tech grid overlay
  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px);
    background-size: 40px 40px;
    top: 0;
    left: 0;
    pointer-events: none;
  }

  .hero-content {
    max-width: 1000px;
    z-index: 2;

    h1 {
      font-size: 48px;
      font-weight: 700;
      margin-bottom: 24px;
      line-height: 1.3;
      letter-spacing: 1px;
    }

    p {
      font-size: 22px;
      margin-bottom: 48px;
      color: rgba(255,255,255,0.85);
      font-weight: 300;
      letter-spacing: 0.5px;
    }

    .hero-actions {
      display: flex;
      justify-content: center;
      gap: 20px;

      .btn {
        padding: 12px 36px;
        font-size: 16px;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s;
        font-weight: 500;
        border: none;
        letter-spacing: 0.5px;
      }

      .btn-primary {
        background: var(--accent);
        color: #fff;

        &:hover {
          background: #18d987;
          transform: translateY(-2px);
        }
      }

      .btn-outline {
        background: transparent;
        border: 1px solid rgba(255,255,255,0.2);
        color: #fff;

        &:hover {
          background: rgba(255,255,255,0.06);
          border-color: var(--accent);
        }
      }
    }
  }
}

.section {
  padding: 80px 0;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 30px;
  }

  .section-title {
    text-align: center;
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 60px;
    color: var(--text);
    position: relative;
    letter-spacing: 1px;

    &::after {
      content: '';
      display: block;
      width: 40px;
      height: 3px;
      background: var(--accent);
      margin: 15px auto 0;
    }
  }
}

// Horizontal Scroll Section
.horizontal-scroll-section {
  position: relative;
  background-color: #050505;
  width: 100%;

  .sticky-wrapper {
    position: sticky;
    top: 0;
    height: 100vh;
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
  }

  .horizontal-track {
    display: flex;
    gap: 60px;
    padding: 0 100px; /* Initial padding */
    will-change: transform;
    /* transition: transform 0.1s linear;  We use raw scroll for smoothness, or add small ease if needed */
  }

  .scroll-item {
    flex-shrink: 0;
  }

  .title-block {
    width: 400px;
    margin-right: 60px;

    h2 {
      font-size: 56px;
      font-weight: 700;
      line-height: 1.2;
      color: #fff;

      .highlight {
        color: var(--text); /* "全新可能" is white in image */
        display: block;
      }
    }
  }

  .feature-card {
    width: 500px;
    height: 380px;
    background: #0f141a;
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 8px;
    padding: 40px;
    display: flex;
    flex-direction: column;
    position: relative;
    transition: all 0.3s ease;

    &:hover {
      border-color: var(--accent);
      transform: translateY(-5px);
      box-shadow: 0 20px 40px rgba(0,0,0,0.4);
    }

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
    }

    .card-number {
      font-size: 14px;
      color: var(--accent);
      font-family: monospace;
      font-weight: 700;
    }

    .category-label {
      font-size: 12px;
      color: #fff;
      background: rgba(34, 229, 143, 0.1);
      border: 1px solid rgba(34, 229, 143, 0.2);
      padding: 4px 10px;
      border-radius: 12px;
      font-weight: 500;
    }

    h3 {
      font-size: 24px;
      color: #fff;
      margin-bottom: 20px;
      font-weight: 600;
    }

    .card-desc {
      font-size: 16px;
      color: #9aa3ad;
      line-height: 1.6;
      flex-grow: 1;
    }

    .card-content-list {
      flex-grow: 1;

      .sub-title {
        color: #fff;
        font-size: 14px;
        margin-bottom: 15px;
        font-weight: 500;
        background: rgba(255,255,255,0.05);
        padding: 8px 12px;
        border-radius: 4px;
        display: inline-block;
      }

      ul {
        padding-left: 20px;
        margin: 0;

        li {
          color: #9aa3ad;
          margin-bottom: 8px;
          font-size: 14px;
        }
      }
    }

    .tags-row {
      display: flex;
      gap: 10px;
      margin-bottom: 20px;

      .tag {
        font-size: 12px;
        color: var(--accent);
        border: 1px solid rgba(34, 229, 143, 0.3);
        padding: 4px 10px;
        border-radius: 20px;
      }
    }

    .card-icon {
      position: absolute;
      bottom: 30px;
      right: 30px;
      font-size: 40px;
      opacity: 0.2;
      filter: grayscale(100%);
      transition: all 0.3s;
    }

    &:hover .card-icon {
      opacity: 1;
      filter: grayscale(0);
      transform: scale(1.1);
    }
  }
}

// Animations
@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-up {
  opacity: 0;
  animation: fadeUp 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;

  &.delay-1 {
    animation-delay: 0.2s;
  }

  &.delay-2 {
    animation-delay: 0.4s;
  }
}

// SOLO Mode Section
.solo-mode {
  padding: 100px 0;
  background-color: var(--bg);
  text-align: center;

  .solo-header {
    max-width: 800px;
    margin: 0 auto 60px;

    h2 {
      font-size: 48px;
      margin-bottom: 24px;
      color: #fff;
      font-weight: 700;
      letter-spacing: 1px;

      .highlight {
        color: var(--accent);
      }
    }

    p {
      font-size: 18px;
      color: var(--muted);
      line-height: 1.6;
      margin-bottom: 40px;
    }

    .btn-solo {
      padding: 14px 40px;
      font-size: 16px;
      border-radius: 4px;
      display: inline-flex;
      align-items: center;
      gap: 8px;
      font-weight: 600;

      .icon {
        font-size: 18px;
      }
    }
  }

  .video-showcase {
    max-width: 1000px;
    margin: 0 auto;

    .video-wrapper {
      position: relative;
      border-radius: 12px;
      overflow: hidden;
      border: 1px solid rgba(255, 255, 255, 0.1);
      box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
      background: #000;

      video {
        width: 100%;
        display: block;
      }

      .play-overlay,
      .pause-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.3);
        transition: all 0.3s;
        pointer-events: none; /* default none */
      }

      .play-overlay {
        pointer-events: auto;
        cursor: pointer;
      }

      .pause-overlay {
        background: transparent;
        opacity: 0;
      }

      &:hover .pause-overlay {
        opacity: 1;
      }

      /* When not playing, show pointer cursor */
      &:not(.is-playing) {
        cursor: pointer;

        .play-overlay {
          background: rgba(0,0,0,0.5);
        }
      }

      /* When playing, show pause on hover */
      &.is-playing {
        cursor: pointer;
      }

      .play-icon,
      .pause-icon {
        font-size: 60px;
        color: #fff;
        background: rgba(255, 255, 255, 0.1);
        width: 100px;
        height: 100px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.2);
        box-shadow: 0 10px 30px rgba(0,0,0,0.3);
        transition: transform 0.3s;
      }

      &:hover .play-icon,
      &:hover .pause-icon {
        transform: scale(1.1);
        background: rgba(34, 229, 143, 0.2);
        border-color: var(--accent);
        color: var(--accent);
      }

      .control-bar {
        display: none;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        padding: 12px 16px;
        align-items: center;
        background: linear-gradient(to top, rgba(0,0,0,0.55), rgba(0,0,0,0));
      }

      .control-btn {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255,255,255,0.12);
        border: 1px solid rgba(255,255,255,0.2);
        color: #fff;
        cursor: pointer;
        transition: all 0.3s;
      }

      .control-btn:hover {
        transform: scale(1.06);
        background: rgba(34, 229, 143, 0.25);
        border-color: var(--accent);
        color: var(--accent);
      }
    }
  }
}

.company-features {
  background-color: var(--bg);

  .feature-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    gap: 30px;

    .feature-item {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      gap: 25px;
      background: var(--surface);
      padding: 40px;
      border-radius: 4px;
      border: 1px solid rgba(255,255,255,0.06);
      transition: all 0.3s;

      &:hover {
        box-shadow: 0 10px 25px rgba(0,0,0,0.45);
      }

      .icon {
        font-size: 32px;
        color: var(--accent);
        background: #0f141a;
        min-width: 64px;
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
      }

      .text {
        h3 {
          font-size: 18px;
          margin-bottom: 10px;
          color: var(--text);
          font-weight: 600;
        }
        p {
          color: var(--muted);
          line-height: 1.6;
          font-size: 14px;
        }
      }
    }
  }
}

.cooperation-modes {
  background-color: var(--bg);

  .modes-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;

    .mode-card {
      padding: 35px;
      background: var(--surface);
      border: 1px solid rgba(255,255,255,0.06);
      border-radius: 4px;
      position: relative;
      transition: all 0.3s;

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 10px 20px rgba(0,0,0,0.45);
        border-color: var(--accent);
      }

      .mode-number {
        font-size: 40px;
        font-weight: 700;
        color: #f1f3f5;
        position: absolute;
        top: 20px;
        right: 20px;
        transition: all 0.3s;
        line-height: 1;
      }

      h3 {
        font-size: 18px;
        margin-bottom: 15px;
        color: var(--text);
        font-weight: 600;
        position: relative;
        z-index: 1;
      }

      p {
        font-size: 13px;
        color: var(--accent);
        margin-bottom: 20px;
        font-weight: 600;
        position: relative;
        z-index: 1;
        background: #0f141a;
        display: inline-block;
        padding: 3px 10px;
        border-radius: 2px;
      }

      .mode-list {
        list-style: none;
        padding: 0;

        li {
          position: relative;
          padding-left: 18px;
          margin-bottom: 8px;
          color: var(--muted);
          font-size: 14px;
          line-height: 1.5;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 7px;
            width: 5px;
            height: 5px;
            background: var(--accent);
            border-radius: 50%;
          }
        }
      }
    }
  }
}

.rd-collaboration {
    background: var(--bg);

    .rd-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
      gap: 30px;

      .rd-card {
        background: var(--surface);
        padding: 35px;
        border-radius: 4px;
        border: 1px solid rgba(255,255,255,0.06);
        display: flex;
        align-items: center;
        gap: 25px;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.45);
          border-color: var(--accent);
        }

        .rd-icon {
          font-size: 32px;
          background: #0f141a;
          min-width: 70px;
          height: 70px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          color: var(--accent);
        }

        .rd-info {
          h3 {
            font-size: 18px;
            margin-bottom: 8px;
            color: var(--text);
            font-weight: 600;
          }

          p {
            color: var(--muted);
            margin-bottom: 12px;
            font-size: 14px;
          }

          .tag {
            display: inline-block;
            background: #0f141a;
            border: 1px solid rgba(255,255,255,0.06);
            color: var(--muted);
            font-size: 12px;
            padding: 2px 10px;
            border-radius: 12px;
            margin-right: 6px;
            transition: all 0.3s;
          }
        }

        &:hover .rd-info .tag {
            border-color: var(--accent);
            color: var(--accent);
        }
      }
    }
  }

.partners {
  background-color: var(--bg);

  .partners-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 25px;

    .partner-card {
      background: var(--surface);
      padding: 30px;
      border-radius: 4px;
      text-align: center;
      transition: all 0.3s;
      border: 1px solid rgba(255,255,255,0.06);

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 10px 20px rgba(0,0,0,0.45);
        border-color: var(--accent);
      }

      h3 {
        font-size: 16px;
        color: var(--text);
        margin-bottom: 8px;
        font-weight: 600;
      }

      .partner-desc {
        font-size: 13px;
        color: var(--muted);
      }
    }
  }
}

.cases {
  background-color: #050505;
  padding: 100px 0;
  overflow: hidden;
  position: relative;

  /* Abstract tech grid overlay */
  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px);
    background-size: 50px 50px;
    top: 0;
    left: 0;
    pointer-events: none;
  }

  .container {
    max-width: 1400px;
  }

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
    padding: 0 20px;

    .section-title {
      margin-bottom: 0;
      text-align: left;
      font-size: 36px;

      &::after {
        display: none;
      }
    }

    .carousel-nav {
      display: flex;
      gap: 10px;
    }

    .nav-btn {
      width: 48px;
      height: 48px;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      transition: all 0.3s;

      &.prev {
        background: #2C2C2C;
        color: #fff;

        &:hover {
          background: #3E3E3E;
        }
      }

      &.next {
        background: #00E599;
        color: #000;

        &:hover {
          background: #00C785;
        }
      }
    }
  }

  .carousel-viewport {
    overflow: visible; /* Allow side cards to be seen */
    width: 100%;
  }

  .carousel-track {
    display: flex;
    gap: 30px;
    transition: transform 0.6s cubic-bezier(0.22, 1, 0.36, 1);
    will-change: transform;
    padding: 0 20px;
  }

  .case-card {
    flex: 0 0 70%;
    background: transparent;
    transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    opacity: 0.4;
    transform: scale(0.92);

    &.active {
      opacity: 1;
      transform: scale(1);
      z-index: 10;
    }

    .card-image {
      height: 450px;
      width: 100%;
      overflow: hidden;
      border-radius: 16px 16px 0 0;
      background: #1a1a1a;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.2) 100%);
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        opacity: 0.8;
        transition: all 0.5s;
      }
    }

    &.active .card-image img {
      opacity: 1;
      transform: scale(1.02);
    }

    .card-content {
      background: #12171d;
      padding: 40px;
      display: flex;
      gap: 60px;
      border-radius: 0 0 16px 16px;
      border: 1px solid rgba(255,255,255,0.08);
      border-top: none;
      position: relative;

      .card-left {
        flex: 0 0 30%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-right: 1px solid rgba(255,255,255,0.1);
        padding-right: 30px;

        h3 {
          font-size: 28px;
          color: #fff;
          margin-bottom: 12px;
          font-weight: 700;
          line-height: 1.2;
        }

        .subtitle {
          color: #00E599;
          font-size: 13px;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          font-weight: 700;
        }
      }

      .card-right {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .desc {
          color: #a0a0a0;
          font-size: 15px;
          line-height: 1.8;
          margin-bottom: 12px;

          strong {
            color: #fff;
            margin-right: 8px;
          }
        }

        .tags {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-top: 20px;

          span {
            background: rgba(0, 229, 153, 0.1);
            color: #00E599;
            padding: 6px 16px;
            border-radius: 20px;
            font-size: 12px;
            border: 1px solid rgba(0, 229, 153, 0.2);
            font-weight: 600;
          }
        }
      }
    }
  }
}

.about-preview {
  background: linear-gradient(135deg, #1e2a38 0%, #2c3e50 100%);
  color: #fff;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at 30% 50%, rgba(255,255,255,0.05) 0%, transparent 50%);
  }

  .about-content {
    text-align: center;
    max-width: 800px;
    margin: 0 auto;
    position: relative;
    z-index: 1;

    .section-title {
      color: #fff;

      &::after {
        background: #00d2ff;
      }
    }

    p {
      font-size: 18px;
      line-height: 1.8;
      margin-bottom: 30px;
      opacity: 0.9;
      font-weight: 300;
    }

    .btn {
        display: inline-block;
        padding: 15px 50px;
        background: #fff;
        color: #0061ff;
        border-radius: 50px;
        font-weight: 700;
        text-decoration: none;
        transition: all 0.3s;

        &:hover {
            transform: translateY(-3px);
            box-shadow: 0 10px 30px rgba(0,0,0,0.2);
        }
    }
  }
}

/* Added styles for Video Carousel and Title Block */
.title-block {
  .title-with-decoration {
    font-size: 64px; /* Increased size */
    font-weight: 800;
    line-height: 1.1;
    color: #fff;
    text-shadow: 0 10px 30px rgba(0,0,0,0.5);

    .highlight-container {
      display: inline-block;
      position: relative;

      .highlight {
        background: linear-gradient(120deg, #fff, var(--accent));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        position: relative;
        z-index: 1;
      }

      &::after {
         content: '';
         position: absolute;
         bottom: 5px;
         left: 0;
         width: 100%;
         height: 12px;
         background: var(--accent);
         opacity: 0.3;
         transform: skewX(-20deg);
         z-index: 0;
      }
    }
  }
}

.video-showcase {
    position: relative;
    /* Replicate carousel styles */
    .carousel-viewport {
      overflow: visible;
      width: 100%;
    }
    .carousel-track {
      display: flex;
      gap: 30px;
      transition: transform 0.6s cubic-bezier(0.22, 1, 0.36, 1);
      will-change: transform;
      padding: 40px 0; /* Add padding for shadow/scale */
    }

    .video-card {
      flex: 0 0 70%;
      background: transparent;
      transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      opacity: 0.4;
      transform: scale(0.85);

      &.active {
        opacity: 1;
        transform: scale(1.35);
        z-index: 10;
      }

      .video-container {
        height: 450px;
        width: 100%;
        overflow: hidden;
        border-radius: 16px; /* Updated border radius */
        background: #000;
        position: relative;
        cursor: pointer;
        box-shadow: 0 20px 50px rgba(0,0,0,0.5); /* Added shadow for depth */

        video {
           width: 100%;
           height: 100%;
           object-fit: cover;
        }

        .play-overlay {
           position: absolute;
           top: 0;
           left: 0;
           width: 100%;
           height: 100%;
           display: flex;
           align-items: center;
           justify-content: center;
           background: rgba(0,0,0,0.3);
           transition: all 0.3s;

           .play-icon {
              font-size: 60px;
              color: #fff;
              background: rgba(255, 255, 255, 0.1);
              width: 100px;
              height: 100px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              backdrop-filter: blur(10px);
              border: 1px solid rgba(255, 255, 255, 0.2);
              transition: transform 0.3s;
           }
        }

        &:hover .play-icon {
           transform: scale(1.1);
           background: rgba(34, 229, 143, 0.2);
           border-color: var(--accent);
           color: var(--accent);
        }

        .control-bar {
           position: absolute;
           bottom: 20px;
           right: 20px;
           z-index: 2;

           .control-btn {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              background: rgba(0,0,0,0.5);
              border: 1px solid rgba(255,255,255,0.3);
              color: #fff;
              cursor: pointer;
              transition: all 0.3s;

              &:hover {
                 background: var(--accent);
                 color: #000;
                 border-color: var(--accent);
              }
           }
        }
      }
    }
  }

</style>
